import { render, staticRenderFns } from "./customerservicerecord.vue?vue&type=template&id=66c95f90"
import script from "./customerservicerecord.vue?vue&type=script&lang=js"
export * from "./customerservicerecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports